import axios from "axios";
import { getCookieValue } from "./cookies";
import { useSWRMutate } from "./useSWR";
import { logger } from "./logger";

const sequenceService = axios.create({
  baseURL: window.ww.sequenceBaseUrl,
  timeout: 5000
});

function createSequenceUser(_, { arg }) {
  const { market } = arg;
  const token = getCookieValue("wwSession");

  logger("Creating sequence user", {
    level: "info"
  });

  return sequenceService.post(
    `/api/v1/ww/create-user?locale=${market}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }
  );
}

function getSequenceRedirectUrl() {
  const token = getCookieValue("wwSession");

  logger("Getting sequence redirect URL", {
    level: "info"
  });

  return sequenceService.get(`/api/v1/ww/clinic-tab-init`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
}

function getStateEligibility() {
  const token = getCookieValue("wwSession");

  logger("Getting state capacity", {
    level: "info"
  });

  return sequenceService.get("/api/v1/ww/state-capacity", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
}

export const useCreateSequenceUser = () =>
  useSWRMutate("createSequenceUser", createSequenceUser, {
    throwOnError: true
  });

export const useSequenceRedirectUrl = () =>
  useSWRMutate("getSequenceRedirectUrl", getSequenceRedirectUrl, {
    throwOnError: true
  });

export const useGetStateEligibility = () =>
  useSWRMutate("getStateEligibility", getStateEligibility, {
    throwOnError: false
  });
